import { injectReducers } from '../../store/reducers'
import AppLayout from '../../components/Layouts/AppLayout'
import { AsyncComponent } from '../../components/Layouts/RouterLayout'
import * as ROUTES from '../../constants/routes'

const getOwnershipContainer = store =>
  import(/* webpackChunkName: "Ownership" */ './reducers')
    .then(module => injectReducers(store, module.default))
    .then(() => import(/* webpackChunkName: "Ownership" */ './containers/OwnershipContainer'))
    .then(module => module.default)

export default (store) => ([
  {
    layout: AppLayout,
    exact: true,
    path: [ROUTES.OWNERSHIP_LIST_PATH],
    component: AsyncComponent(() => getOwnershipContainer(store))
  }
])
